export const NEW_BOX_LOADING = 'NEW_BOX_LOADING'
export const NEW_BOX_ERROR = 'NEW_BOX_ERROR'

export const DELETE_BOX_LOADING = 'DELETE_BOX_LOADING'
export const DELETE_BOX_ERROR = 'DELETE_BOX_ERROR'
export const DELETE_BOX_SUCCESS = 'DELETE_BOX_SUCCESS'